// import { addFilter, filterItems } from "@/redux/features/filterSlice";
import axiosInstance from "@/service/axiosInstance";
import { customSelectStyle } from "@/styles/customStyles";
import {
  APP_NAME,
  ClassificationTypes,
  Gender,
  PRIVATE_PRODUCTS_ACCESS_ROLES,
  ToastOptions,
} from "@/utils/enum";
import axios from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";

export interface filter {
  eventsType: any;
  eventsMode: any;
  location: any;
  currentPage: any;
  school: any;
  age: any;
  category: any;
  gender: any;
  registrationStatus: any;
  privateEvents?: boolean;
}
interface filterProps {
  handleResetFilter: any;
  getData: (currentPage: any, filter: any) => Promise<void>;
  currentPage: any;
  setcurrentPage: any;
  isLeaderboard?: any;
  filter: any;
  addFilter: any;
}
const eventOptions = [
  "Competition",
  "Workshop",
  "Premier Competition",
  "Premier Sports",
  "Sports",
];

const eventTypeOptions = ["Online", "Offline"];

const categories = [ClassificationTypes.Individual, ClassificationTypes.Group];

const gender = [ClassificationTypes.Male, ClassificationTypes.Female];

const ageOptions = [
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
];

const DropdownOne = ({
  handleResetFilter,
  setcurrentPage,
  getData,
  currentPage,
  isLeaderboard,
  filter,
  addFilter,
}: filterProps) => {
  // const filter = useSelector(filterItems);

  const dispatch = useDispatch();

  const [zones, setZones] = useState([]);
  const [schools, setSchools] = useState<any>([]);

  const [locations, setLocations] = useState<any>([]);

  const [locationLoading, setLocationLoading] = useState(false);
  const [schoolLoading, setShoolLoading] = useState(false);

  const userRole = useSelector((state: any) => state.auth.userRole);

  const handleEventChange = (e: ChangeEvent<HTMLInputElement>) => {
    const event = e.target.value;
    if (e.target.checked) {
      dispatch(
        addFilter({ ...filter, eventsType: [...filter?.eventsType, event] }),
      );
    } else {
      dispatch(
        addFilter({
          ...filter,
          eventsType: filter?.eventsType.filter((item: any) => item !== event),
        }),
      );
    }
  };

  const handleRegistrationsOpenChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    dispatch(
      addFilter({
        ...filter,
        registrationsOpen: isChecked,
      }),
    );
  };

  const handleEventTypeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const event = e.target.value;
    if (e.target.checked) {
      dispatch(
        addFilter({ ...filter, eventsMode: [...filter?.eventsMode, event] }),
      );
    } else {
      dispatch(
        addFilter({
          ...filter,
          eventsMode: filter?.eventsMode.filter((item: any) => item !== event),
        }),
      );
    }
  };

  const handleLocationChange = (e: any) => {
    setShoolLoading(true);

    if (e) {
      dispatch(addFilter({ ...filter, location: e }));
      const schoolsWithLocation = zones
        .filter((doc: any) => doc.attributes.Zone === e.value)
        .sort((a: any, b: any) => {
          const schoolA =
            a.attributes.School_Name.data?.attributes.name?.toUpperCase() || "";
          const schoolB =
            b.attributes.School_Name.data?.attributes.name?.toUpperCase() || "";

          return schoolA.localeCompare(schoolB);
        })
        .map((school: any) => {
          const name = school.attributes.School_Name.data?.attributes.name;
          return {
            value: name,
            label: name,
          };
        });

      const uniqueSchools = Array.from(
        new Map(schoolsWithLocation.map((s) => [s.value, s])).values(),
      );

      setSchools(uniqueSchools);
    } else {
      setSchools([]);
      dispatch(addFilter({ ...filter, school: null, location: null }));
    }
    setShoolLoading(false);
  };

  const handleSchoolChange = (e: any) => {
    dispatch(addFilter({ ...filter, school: e }));
  };

  const handleAgeChange = (e: any) => {
    dispatch(addFilter({ ...filter, age: e }));
  };

  const handleGenderChange = (e: ChangeEvent<HTMLInputElement>) => {
    const gender = e.target.value;
    if (e.target.checked) {
      dispatch(addFilter({ ...filter, gender }));
    }
  };

  const handleCategoryChange = (e: ChangeEvent<HTMLInputElement>) => {
    const category = e.target.value;
    if (e.target.checked) {
      dispatch(addFilter({ ...filter, category }));
    }
  };

  const getLocations = async () => {
    try {
      setLocationLoading(true);
      const data = await axiosInstance.get("/locations");
      if (!data.data) {
        toast.error("Unable to fetch schools. Please try again.", ToastOptions);
      } else {
        let locs: any = [];
        data.data.map((doc: any) => {
          locs.push({
            value: doc.attributes.Zone,
            label: doc.attributes.Zone,
          });
        });
        const uniqueLocs = Array.from(
          new Set(locs.map((loc: any) => JSON.stringify(loc))),
        ).map((loc: any) => JSON.parse(loc));
        setZones(data.data);
        setLocations(uniqueLocs);
        return locs;
      }
    } catch (error) {
      console.log("Error in getLocations", error);
    } finally {
      setLocationLoading(false);
    }
  };

  const getMetabaseSchools = async () => {
    try {
      const response = await axios.post(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/metabase-schools`,
      );
      const data = response.data;

      if (!data || !Array.isArray(data)) {
        toast.error("Failed to fetch schools", ToastOptions);
        return null;
      }

      let schoolData = data.map((item: any) => ({
        value: item.venue_name,
        label: item.venue_name,
      }));

      const sortedSchoolData = schoolData.sort((a, b) => {
        const schoolA = a.value.toUpperCase();
        const schoolB = b.value.toUpperCase();
        return schoolA.localeCompare(schoolB);
      });

      setSchools(sortedSchoolData);
    } catch (error: any) {
      console.log(
        "Error in getSchools :>> ",
        error.response?.data || error.message,
      );
      return null;
    }
  };

  const handlePrivateProducts = async (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(addFilter({ ...filter, privateEvents: e.target.checked }));
  };

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_APP_NAME == APP_NAME.SUMMER_CAMP_PRIVATE) {
      getMetabaseSchools();
    } else {
      getLocations();
    }
  }, []);

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        setcurrentPage(1);
        await new Promise((resolve) => {
          const prevFilter = { ...filter };
          const newFilter = {
            ...prevFilter,
            currentPage: 1,
          };
          dispatch(addFilter(newFilter));
          resolve(newFilter);
          return newFilter;
        });
        const updatedFilter = { ...filter, currentPage: 1 };
        console.log("Updated filter:", updatedFilter);
        getData(0, updatedFilter);
      }}
    >
      <div className="">
        <div className="col-12 ">
          <div
            className="col-12"
            style={{
              marginBottom: "0.938rem",
            }}
          >
            <div
              style={{
                color: "#212121",
                fontWeight: "500",
                fontSize: "2rem",
                marginBottom: "1.25rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              Filter{" "}
            </div>
            {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Event
              </div>
            )}

            {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
              <ul
                className="style-none d-flex flex-wrap"
                style={{
                  gap: "13px",
                }}
              >
                {eventOptions.map((event) => (
                  <li key={event} className="d-flex align-items-center">
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      name="Events"
                      value={event}
                      checked={filter?.eventsType?.includes(event)}
                      onChange={handleEventChange}
                      id={event}
                    />
                    <label className="cursor-pointer" htmlFor={event}>
                      {event}
                    </label>
                  </li>
                ))}
              </ul>
            )}
          </div>
          {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
            <div
              className="col-12"
              style={{
                marginBottom: "0.938rem",
              }}
            >
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Event Type
              </div>
              <ul
                className="style-none d-flex flex-wrap"
                style={{
                  gap: "13px",
                }}
              >
                {eventTypeOptions.map((event) => (
                  <li key={event} className="d-flex align-items-center">
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      name="Events"
                      value={event}
                      checked={filter?.eventsMode?.includes(event)}
                      onChange={handleEventTypeChange}
                      id={event}
                    />
                    <label className="cursor-pointer" htmlFor={event}>
                      {event}
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {!isLeaderboard && (
            <div className="col-12" style={{ marginBottom: "0.938rem" }}>
              {/* <div
              style={{
                color: "#212121",
                fontWeight: "500",
                fontSize: "1.25rem",
              }}
            >
              Registrations Open
            </div> */}
              <ul className="style-none d-flex flex-wrap">
                <li className="d-flex align-items-center">
                  <input
                    className="form-check-input me-2"
                    style={{
                      cursor: "pointer",
                      width: "1.2rem",
                      accentColor: "#3F41D1",
                    }}
                    type="checkbox"
                    name="RegistrationsOpen"
                    checked={filter?.registrationsOpen ?? true}
                    onChange={handleRegistrationsOpenChange}
                    id="registrationsOpen"
                  />
                  <label htmlFor="registrationsOpen" className="cursor-pointer">
                    Registrations Open
                  </label>
                </li>
              </ul>
            </div>
          )}
          {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.SUMMER_CAMP_PRIVATE && (
            <div className="col-12">
              <div
                style={{
                  marginBottom: "0.938rem",
                }}
              >
                <div
                  style={{
                    color: "#212121",
                    fontWeight: "500",
                    fontSize: "1.25rem",
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  Location
                </div>
                <Select
                  className="custom-select"
                  classNamePrefix={"custom-select"}
                  placeholder="Select Location"
                  isClearable
                  instanceId="selectbox1"
                  onChange={handleLocationChange}
                  options={locations}
                  value={filter?.location}
                  isLoading={locationLoading}
                  styles={customSelectStyle}
                />
              </div>
            </div>
          )}
          <div className="col-12">
            <div
              style={{
                marginBottom: "0.938rem",
              }}
            >
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                School
              </div>
              <Select
                className="custom-select"
                placeholder="Select School"
                isClearable
                instanceId="selectbox2"
                onChange={handleSchoolChange}
                options={schools}
                value={filter?.school}
                isLoading={schoolLoading}
                styles={customSelectStyle}
              />
            </div>
          </div>

          <div className="col-12">
            <div
              style={{
                marginBottom: "0.938rem",
              }}
            >
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Age
              </div>
              <Select
                className="custom-select"
                placeholder="Select Age"
                isClearable
                instanceId="selectbox3"
                onChange={handleAgeChange}
                options={ageOptions}
                value={filter?.age}
                isLoading={!ageOptions.length}
                styles={customSelectStyle}
              />
            </div>
          </div>

          <div
            className="col-12"
            style={{
              marginBottom: "0.938rem",
            }}
          >
            <div
              className=""
              style={{
                color: "#212121",
                fontWeight: "500",
                fontSize: "1.25rem",
                display: "flex",
                justifyContent: "start",
              }}
            >
              Gender
            </div>
            <ul className="style-none d-flex flex-wrap justify-content-start">
              <>
                <div className="form-check d-flex align-items-center mx-2">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="gender"
                    id={Gender.Male}
                    value={Gender.Male}
                    onChange={handleGenderChange}
                    checked={filter?.gender === Gender.Male}
                  />
                  <label
                    htmlFor={Gender.Male}
                    className="form-check-label"
                    style={{
                      fontSize: "1rem",
                      fontWeight: 400,
                      cursor: "pointer",
                    }}
                  >
                    {Gender.Male}
                  </label>
                </div>

                <div className="form-check d-flex align-items-center mx-2">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="gender"
                    id={Gender.Female}
                    value={Gender.Female}
                    onChange={handleGenderChange}
                    checked={filter?.gender === Gender.Female}
                  />
                  <label
                    htmlFor={Gender.Female}
                    className="form-check-label"
                    style={{
                      fontSize: "1rem",
                      fontWeight: 400,
                      cursor: "pointer",
                    }}
                  >
                    {Gender.Female}
                  </label>
                </div>
              </>
            </ul>
          </div>
          {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
            <div className="col-12">
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Category
              </div>

              <ul className="style-none d-flex flex-wrap justify-content-start mb-10">
                <>
                  <div className="form-check d-flex align-items-center mx-2">
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="category"
                      id={ClassificationTypes.Individual}
                      value={ClassificationTypes.Individual}
                      onChange={handleCategoryChange}
                      checked={
                        filter?.category === ClassificationTypes.Individual
                      }
                    />
                    <label
                      htmlFor={ClassificationTypes.Individual}
                      className="form-check-label"
                      style={{
                        fontSize: "1rem",
                        fontWeight: 400,
                        cursor: "pointer",
                      }}
                    >
                      {ClassificationTypes.Individual}
                    </label>
                  </div>

                  <div className="form-check d-flex align-items-center mx-2">
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="category"
                      id={ClassificationTypes.Group}
                      value={ClassificationTypes.Group}
                      onChange={handleCategoryChange}
                      checked={filter?.category === ClassificationTypes.Group}
                    />
                    <label
                      htmlFor={ClassificationTypes.Group}
                      className="form-check-label"
                      style={{
                        fontSize: "1rem",
                        fontWeight: 400,
                        cursor: "pointer",
                      }}
                    >
                      {ClassificationTypes.Group}
                    </label>
                  </div>
                </>
              </ul>
            </div>
          )}

          {PRIVATE_PRODUCTS_ACCESS_ROLES.includes(userRole) && (
            <div className="col-12">
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Private Events
              </div>
              <div className="form-check form-switch d-flex align-items-end gap-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="showPrivateEvents"
                  style={{ cursor: "pointer", height: "1.5rem", width: "3rem" }}
                  checked={filter.privateEvents}
                  onChange={handlePrivateProducts}
                />
                <label
                  className="form-check-label"
                  htmlFor="showPrivateEvents"
                  style={{ cursor: "pointer", height: "1.5rem" }}
                >
                  Show Private Products
                </label>
              </div>
            </div>
          )}
        </div>
        <div className="col-12">
          <button
            className="fw-300 apply-search w-100 mt-20 mb-25"
            style={{
              borderRadius: "2.5rem",
            }}
          >
            <i className="fa-light fa-magnifying-glass"></i>
            <span
              style={{
                fontSize: "0.875rem",
                fontWeight: 500,
              }}
            >
              Search
            </span>
          </button>
        </div>

        <div className="col-12">
          <div className="d-flex justify-content-center form-widget">
            <button
              onClick={handleResetFilter}
              className="reset-btn"
              style={{ cursor: "pointer", background: "none", border: "none" }}
            >
              <i className="fa-regular fa-arrows-rotate"></i>
              <span
                style={{
                  fontWeight: 400,
                  fontSize: "1rem",
                  marginLeft: "0.5rem",
                }}
              >
                Reset Filter
              </span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default DropdownOne;
